export class Phone {
  public number: string;
  public leaveMsg: boolean;
  public sendSms: boolean;

  public constructor(number: string, leaveMsg: boolean, sendSms: boolean) {
    this.number = number;
    this.leaveMsg = leaveMsg;
    this.sendSms = sendSms;
  }
}
